module.exports = __webpack_public_path__ + "img/sri-lanka-logo-icon.0a8a9370.png";